import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.auth');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-auth',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.auth/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-shell {
  min-height: 100vh;
  display: grid;
  grid-template-columns: clamp(420px, 36vw, 580px) minmax(0, 1fr);
  background: var(--kiom-surface);
}

.auth-story {
  position: relative;
  overflow: hidden;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  padding: 48px clamp(40px, 4vw, 64px) 36px;
  color: #f7fbfa;
  background: #123b37;
}

.auth-story::before,
.auth-story::after {
  position: absolute;
  content: "";
  border: 1px solid rgba(191, 219, 211, 0.18);
  border-radius: 999px;
  pointer-events: none;
}

.auth-story::before {
  width: 440px;
  height: 440px;
  right: -250px;
  top: -150px;
}

.auth-story::after {
  width: 600px;
  height: 600px;
  left: -380px;
  bottom: -380px;
}

.brand,
.mobile-brand {
  display: flex;
  align-items: center;
}

.brand {
  position: relative;
  z-index: 1;
}

.kiom-logo {
  display: block;
  width: 141px;
  height: auto;
  flex: 0 0 auto;
}

.product-name {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid rgba(216, 238, 230, 0.38);
  color: #f7fbfa;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.story-copy {
  position: relative;
  z-index: 1;
  margin: auto 0;
}

.story-copy h1 {
  margin: 0;
  font-size: clamp(40px, 3.4vw, 52px);
  font-weight: 750;
  line-height: 1.15;
  letter-spacing: -0.045em;
}

.auth-main {
  min-width: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.mobile-brand {
  display: none;
  padding: 12px 24px;
  border-bottom: 1px solid #315853;
  background: #123b37;
}

.mobile-brand .kiom-logo {
  width: 116px;
}

.mobile-brand .product-name {
  min-height: 28px;
  margin-left: 12px;
  padding-left: 12px;
  font-size: 14px;
}

.auth-content {
  width: min(100%, 960px);
  margin: auto;
  padding: 64px clamp(32px, 4vw, 64px);
}

.app-loading {
  position: fixed;
  z-index: 100;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(15, 32, 31, 0.2);
  backdrop-filter: blur(4px);
}

.loading-spinner {
  width: 44px;
  height: 44px;
  color: var(--kiom-primary);
}

@media (max-width: 1050px) {
  .auth-shell {
    display: block;
  }
  .auth-story {
    display: none;
  }
  .mobile-brand {
    display: flex;
  }
  .auth-content {
    width: min(100%, 760px);
    padding-top: 48px;
  }
}
@media (max-width: 520px) {
  .mobile-brand {
    padding: 10px 20px;
  }
  .mobile-brand .kiom-logo {
    width: 104px;
  }
  .mobile-brand .product-name {
    min-height: 26px;
    margin-left: 10px;
    padding-left: 10px;
    font-size: 13px;
  }
  .auth-content {
    padding: 34px 20px 48px;
  }
}`],
})
export class LayoutAuthComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }
}

export default LayoutAuthComponent;